import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToastrMessageService} from '../../services/toastr-message/toastr-message.service';
import {LicenseCodesService} from '../../services/license-codes/license-codes.service';
import {TranslateService} from '@ngx-translate/core';
import {ILicenseKey} from "../../core/interfaces/licenseKeys";
import {SubscriptionsService} from "../../services/subscriptions/subscriptions.service";

@Component({
  selector: 'kt-license-modal',
  templateUrl: './license-modal.component.html',
  styleUrls: ['./license-modal.component.scss']
})
export class LicenseModalComponent implements OnInit {

  licenseCode = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<LicenseModalComponent>,
    private toast: ToastrMessageService,
    private licenseCodes: LicenseCodesService,
    private translate: TranslateService,
    private subscriptions: SubscriptionsService
  ) { }

  ngOnInit(): void {
  }
  submit() {
    this.licenseCodes.getSingleLicenseCode(this.licenseCode).subscribe((code:any) => {
      if (code.length && code[0].status === 'active') {
        this.toast.message(this.translate.instant('LICENSE_MODAL.ERROR'), '', 'toast-danger')
        return;
      }
      if (code && code.length) {
        code = code[0] as ILicenseKey;
        code.activatedAt = Date.now();
        code.deactivatedAt = null;
        code.currentUser.email = this.data.user.email;
        code.currentUser.id = this.data.user.id;
        code.status = 'active';
        this.subscriptions.getUserDevice(this.data.user).subscribe((device) => {
          if (device) {
            code.deviceId = device.deviceName;
            this.licenseCodes.setLicenseCode(code).then(() => {
              this.dialogRef.close(code);
            });
          }
        });
      } else {
        this.toast.message(this.translate.instant('LICENSE_MODAL.ERROR'), '', 'toast-danger')
      }
    });
  }

}
